import React from 'react';
import { TranslationKey } from './../../../../types/translation/TranslationKey';
import { User } from '../../../../types/user';
import { t } from '../../../../types/translation/Translator';
import { UserAddIcon } from '../../../icons/User/UserAddIcon';
import { itemsContainText } from '../../../../util/string.util';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { UserFilterInnerContent, UserFilterDropdownContent } from './DropdownContent';
import { FilterProps } from '../common/filter.util';

export class UserFilter extends BaseFilter<User> {
  users: Map<string, User>;

  constructor(users: Map<string, User>) {
    super();
    this.users = users;
  }

  toLabel(props: BaseFilterProps): string {
    return t(TranslationKey.user).plural.label;
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <UserFilterInnerContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <UserFilterDropdownContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  toIcon(props: BaseFilterProps): React.JSX.Element {
    return <UserAddIcon className={this.className} />;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.user?.size || 0;
  }

  search(item: User, textFilter: string) {
    const user = this.users.get(item.userId);
    return itemsContainText(textFilter, [user?.firstName, user?.lastName, user?.email]);
  }

  static filter(filterProps: FilterProps, item?: User) {
    if (filterProps.user?.size && (!item || !filterProps.user.has(item.id))) return false;
    return true;
  }
}
